import { render, staticRenderFns } from "./AddTransferStock.vue?vue&type=template&id=74bc7ab8"
import script from "./AddTransferStock.vue?vue&type=script&lang=js"
export * from "./AddTransferStock.vue?vue&type=script&lang=js"
import style0 from "./AddTransferStock.vue?vue&type=style&index=0&id=74bc7ab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports